import { HidWedgeAdapter } from './hidWedgeAdapter'
import { BRIDGE_READY_EVENT, isNativeBridgeAvailable } from './leapNativeBridge'
import { NativeSdkAdapter } from './nativeSdkAdapter'
import type { ScannerAdapter } from './types'

export type {
  ConnectionEvent,
  ErrorEvent,
  KnownDevice,
  ScannerAdapter,
  ScannerStatus,
  ScannerType,
  TagEvent,
} from './types'

export {
  isNativeBridgeAvailable,
  getNativeBridge,
  nativeListRfd8500,
  subscribeNativeTag,
  subscribeNativeConnection,
  subscribeNativeError,
  initLeapBridge,
  ensureLeapBridgeInit,
  BRIDGE_READY_EVENT,
} from './leapNativeBridge'

let cached: ScannerAdapter | null = null

if (typeof window !== 'undefined') {
  window.addEventListener(BRIDGE_READY_EVENT, () => {
    cached = null
  })
}

/** Prefer Zebra SDK bridge (WebView or Connector WebSocket); otherwise HID wedge. */
export function createScannerAdapter(): ScannerAdapter {
  if (isNativeBridgeAvailable()) {
    cached = new NativeSdkAdapter()
    return cached
  }
  cached = new HidWedgeAdapter()
  return cached
}

export function getScannerAdapter(): ScannerAdapter {
  if (cached && cached.kind === 'native' && !isNativeBridgeAvailable()) {
    cached = null
  }
  if (cached && cached.kind === 'hid' && isNativeBridgeAvailable()) {
    cached = null
  }
  return cached ?? createScannerAdapter()
}
